import type { TradingCall } from '../types/TradingCall';

/** Shared formatting for paper-trading / virtual position UI (no external deps). */
export function formatMoney(n: number | undefined | null): string {
  if (n == null || !Number.isFinite(n)) return '—';
  return n.toFixed(2);
}

/** One line per leg for display (strike, right, expiry). */
export function formatLegLines(
  call: TradingCall,
  labels?: { long: string; short: string; call: string; put: string }
): string[] {
  const legs = call.strategy.details.legs;
  if (!legs?.length) return [];
  const longL = labels?.long ?? 'Long';
  const shortL = labels?.short ?? 'Short';
  const callL = labels?.call ?? 'call';
  const putL = labels?.put ?? 'put';
  return legs.map((l) => {
    const side = l.type === 'BUY' ? longL : shortL;
    const right = l.optionType === 'CALL' ? callL : putL;
    return `${side} ${l.strike} ${right} · ${l.expiry}`;
  });
}
